module.exports = "./img/cccaa63cfefb0324584c0c5282ca3d76.jpg";